import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const SelectListCore = ({ fixedHeight = true, maxMenuItems, innerRef, children, className, ...rest })=>{
    const selectListCss = classNames(className, 'cb-select-list', {
        [`max-menu-items-${maxMenuItems ?? ''}`]: maxMenuItems
    }, {
        'fixed-height': fixedHeight
    });
    return jsx("div", {
        ref: innerRef,
        className: selectListCss,
        ...rest,
        children: children
    });
};
SelectListCore.displayName = 'SelectList.Core';

export { SelectListCore };
//# sourceMappingURL=SelectList.Core.es.js.map
